/**
 * CBAIQ Branding Configuration
 * Single source of truth for all product branding.
 * DO NOT hardcode these values elsewhere - always import from here.
 */

export const APP_NAME = "CBAIQ";
export const TAGLINE = "Plain-English answers to complex workplace agreements.";

export const BRANDING = {
  name: APP_NAME,
  tagline: TAGLINE,
  
  // SEO & Metadata
  metaDescription: `${APP_NAME} - ${TAGLINE}`,
  ogTitle: APP_NAME,
  ogDescription: TAGLINE,
  
  // PDF Export
  pdfHeader: APP_NAME,
  pdfSubheader: TAGLINE,
  pdfFooter: `Generated by ${APP_NAME}`,
  pdfFilePrefix: "CBAIQ_Answer",
  pdfMetadataTitle: `${APP_NAME} Report`,
  
  // Legal
  disclaimerProduct: APP_NAME,
  
  // Messages
  loginSuccess: `Welcome to ${APP_NAME}`,
  registerSuccess: `Welcome to ${APP_NAME}! Your account has been created.`,
};

export default BRANDING;
